import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { Row, Card, Space, Button, Form } from "@masterteam/mt-design-react";

import AdminPage from "../AdminPage";
import StatusTab, { statusValidationSchema } from "./StatusTab";

import api from "../../providers/api";

import { addToast } from "../../helpers";

import "./style.scss";

function SystemThreshold() {
  const [initialValues, setInitialValues] = useState({ statuses: [] });
  const [loading, setLoading] = useState(true);
  const intl = useIntl();

  async function getKPITypesConfigs() {
    setLoading(true);
    try {
      const res = await api.sysPerf.getAll();
      setInitialValues({ statuses: res.Data });
      setLoading(false);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    }
  }

  useEffect(() => {
    getKPITypesConfigs();
  }, []);

  const handleSubmit = async (values, { setIsSubmitting }) => {
    const body = values.statuses;
    try {
      const res = await api.sysPerf.update(body);
      if (res?.StatusCode === "Success") {
        addToast.success("toast.successSave");
      }
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <AdminPage title={intl.formatMessage({ id: "common.system-thresholds" })}>
      <div className="system-config__content">
        <Card loading={loading} className="system-config__form">
          <Form
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={statusValidationSchema("statuses")}
          >
            {({ isSubmitting }) => (
              <>
                <Space direction="vertical" size="large">
                  <Row justify="end">
                    <Button
                      type="submit"
                      size="large"
                      loading={isSubmitting}
                      fixed
                    >
                      {intl.formatMessage({ id: "common.save" })}
                    </Button>
                  </Row>
                  <StatusTab name="statuses" disabled={isSubmitting} />
                </Space>
              </>
            )}
          </Form>
        </Card>
      </div>
    </AdminPage>
  );
}

export default SystemThreshold;
